import React from 'react';
// template components
import RelatedLinks from '@nmx/template/dist/componentLibrary/layout/Footer/RelatedLinks';

export default () => {
  const linkItems = [
    {
      linkUrl: 'https://www.whatcarecosts.com/NorthwesternMutual/nm1/',
      linkId: 'related-links-cost-of-care-calculator',
      linkText: 'Cost of Care Calculator',
      isOutgoingLink: true,
      children: '',
    },
    {
      linkUrl: 'https://news.northwesternmutual.com/2018-care-study/',
      linkId: 'related-links-care-study',
      linkText: 'C.A.R.E. Study',
      isOutgoingLink: true,
      children: '',
    },
  ];

  return (
    <RelatedLinks
      sectionId='related-links-long-term-care-planning-page'
      linkItems={linkItems}
      moduleName='related-links'
      moduleVariation='A'
      backgroundVariant='lightA'
      disableBottomPadding />
  );
};
